import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin, FaInstagram, FaGithub, FaEnvelope, FaPhone } from 'react-icons/fa';
import { SiLinktree } from 'react-icons/si';

const Hero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.15
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 10
      }
    }
  };

  const socialLinks = [
    { icon: <FaLinkedin />, url: 'https://linkedin.com/in/vrajupadhyay', label: 'LinkedIn' },
    { icon: <FaInstagram />, url: 'https://instagram.com/vraj_upadhyay12', label: 'Instagram' },
    { icon: <SiLinktree />, url: 'https://linktr.ee/vrajupadhyay', label: 'Linktree' },
    { icon: <FaGithub />, url: 'https://github.com/vrajupadhyay', label: 'GitHub' },
  ];

  return (
    <section id="home" className="hero-section">
      <motion.div
        className="hero-content"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div className="hero-badges" variants={itemVariants}>
          <motion.span 
            className="badge-glow mvp"
            whileHover={{ scale: 1.1, rotate: [0, -5, 5, 0] }}
            transition={{ duration: 0.3 }}
          >
            Microsoft MVP 2025
          </motion.span>
          <motion.span 
            className="badge-glow current"
            whileHover={{ scale: 1.1, rotate: [0, 5, -5, 0] }}
            transition={{ duration: 0.3 }}
          >
            T&P Coordinator @ BVM
          </motion.span>
          <motion.span 
            className="badge-glow upcoming"
            whileHover={{ scale: 1.1, rotate: [0, -5, 5, 0] }}
            transition={{ duration: 0.3 }}
          >
            Upcoming @ NDDB
          </motion.span>
        </motion.div>

        <motion.h1 
          className="hero-title" 
          variants={itemVariants}
        >
          Hi, I'm <motion.span 
            className="gradient-text"
            animate={{
              backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
            }}
            transition={{
              duration: 5,
              repeat: Infinity,
              ease: "linear"
            }}
          >
            Vraj Upadhyay
          </motion.span>
        </motion.h1>

        <motion.p className="hero-subtitle" variants={itemVariants}>
          Full Stack Developer | Mobile App Developer | Microsoft MVP
        </motion.p>

        <motion.p className="hero-description" variants={itemVariants}>
          Passionate about building scalable, high-impact digital solutions.
          <br />
          Specializing in modern web and mobile app development.
        </motion.p>

        <motion.div className="hero-location" variants={itemVariants}>
          📍 Anand, Gujarat, India
        </motion.div>

        <motion.div className="hero-contact" variants={itemVariants}>
          <a href="tel:+917202045251" className="contact-item">
            <FaPhone /> +91 72020 45251
          </a>
          <a href="mailto:vrajupadhyay12@gmail.com" className="contact-item">
            <FaEnvelope /> vrajupadhyay12@gmail.com
          </a>
        </motion.div>

        <motion.div className="social-links" variants={itemVariants}>
          {socialLinks.map((social, index) => (
            <motion.a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              whileHover={{ 
                scale: 1.2, 
                rotate: [0, -10, 10, 0],
                transition: { duration: 0.3 }
              }}
              whileTap={{ scale: 0.9 }}
              aria-label={social.label}
            >
              {social.icon}
            </motion.a>
          ))}
        </motion.div>

        <motion.div className="hero-cta" variants={itemVariants}>
          <motion.a
            href="#contact"
            className="btn btn-primary"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Let's Connect
          </motion.a>
          <motion.a
            href="#portfolio"
            className="btn btn-secondary"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            View My Work
          </motion.a>
        </motion.div>
      </motion.div>

      <motion.div
        className="hero-illustration"
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.5 }}
      >
        <div className="floating-shapes">
          <motion.div
            className="shape shape-1"
            animate={{
              y: [0, -30, 0],
              rotate: [0, 180, 360]
            }}
            transition={{
              duration: 8,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
          <motion.div
            className="shape shape-2"
            animate={{
              y: [0, 30, 0],
              rotate: [0, -180, -360]
            }}
            transition={{
              duration: 10,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
          <motion.div
            className="shape shape-3"
            animate={{
              y: [0, -20, 0],
              x: [0, 20, 0],
              rotate: [0, 90, 180, 270, 360]
            }}
            transition={{
              duration: 9,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
